export default __webpack_public_path__ + "931b44dd00e355d5f89f86faa2851f43.svg";